import { useEffect } from 'react';
import { RouteList } from '@zg-rentals/route-list';
import { Box, Heading, Page, Text } from '@zillow/constellation-10';
import { useMonitor } from '@zg-rentals/rental-manager-env';

const FrontPage = () => {
  const increment = useMonitor();
  useEffect(() => {
    increment({ name: 'render.FrontPage', amount: 1 });
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- preserving existing behavior; not re-verified
  }, []);
  return (
    <Page.Root>
      <Page.Header>
        <Heading level={3}>billing-portal-web-static</Heading>
      </Page.Header>
      <Page.Content>
        <Text>Hello, welcome to billing-portal-web-static. 👻</Text>
        <Box css={{ marginTop: 'md', marginBottom: 'md' }}>
          {__DEV__ && <RouteList nodeSocketApi="ws://localhost:5001" />}
        </Box>
      </Page.Content>
    </Page.Root>
  );
};

export default FrontPage;
